module.exports = __webpack_public_path__ + "img/performance.baf0dff.svg";